import type React from 'react';
import EmailWarning from './controls/email-warning';

export interface IProps {}

const AuthenticatedControls: React.FC<IProps> = () => {
  return (
    <>
      <EmailWarning />
    </>
  );
};

export default AuthenticatedControls;
